export const ja = {
  "BACK_BUTTON": "戻る",
  "NEXT_BUTTON": "次へ",
  "I_AGREE": "賛成です",
  "FINISH_BUTTON": "完了",
  "CHOICES_TITLE": "選択肢",
  "SELECT_INPUT": "名前",
  "MULTICHOICE_PEER_PLACEHOLDER": "対象者を選択",
  "MULTICHOICE_PEER_REQUIRED_ERROR": "少なくとも1名を選択してください。",
  "MULTICHOICE_OTHER_LABEL": "その他（具体的に記入）",
  "MULTICHOICE_OTHER_PLACEHOLDER": "具体的に記入してください",
  "MULTICHOICE_OTHER_TEXT_REQUIRED": "「その他」の内容を記入してください。",
  "MULTICHOICE_OTHER_TEXT_TOO_LONG": "回答は1000文字以内で入力してください。",
  "MULTICHOICE_CLEAR_SELECTION": "選択を解除",
  "LIKERT_HINT": "対象者を選択してスコアを設定してください。",
  "LIKERT_SCORE_LABEL": "スコア",
  "LIKERT_INCOMPLETE_ERROR": "各行で対象者とスコアの両方を選択してください。",
  "LIKERT_INVALID_ERROR": "1つ以上のスコアが許可範囲外です。",
  "EMPTY_ERROR": "必須項目です",
    "SUBMIT_ERROR": "回答を送信できませんでした。入力内容を確認してください。",
  "SENDING_DATA": "データを送信中...",
  "LOADING": "読み込み中...",
  "MAX_SELECT_ERROR": "選択可能な最大数は：",
  "FORM_ALREADY_ANSWERED": "ご回答ありがとうございます！",
  "THANK_YOU": "Organizational Network Analysis (ONA) 調査にご協力いただき、誠にありがとうございます。フィードバックが送信されました。",
  "MAX_SELECT_CUSTOM_MESSAGE": "最大オプション値に達しました",
  "SKILL_PLACEHOLDER": "スキルレベル",
  "QR_SELECT_TITLE": "あなたの名前を選択してください",
  "QR_SELECT_PLACEHOLDER": "名前を検索...",
  "QR_NO_PARTICIPANTS": "参加者がいません。すべての参加者がすでに回答しています。",
  "QR_SURVEY_NOT_FOUND": "調査が見つかりません",
  "QR_LOAD_ERROR": "参加者を読み込めません。もう一度お試しください。",
  "QR_PARTICIPANT_ALREADY_ANSWERED": "この参加者はすでに調査を完了しています。もう一度名前を選択してください。",
  "QR_BACK_TO_SELECTION": "名前選択に戻る",
  "companyValues": {
    "PASSION": "私たちが行うすべてに情熱を持っています",
    "INNOVATING": "常に革新しています",
    "CONFIDENCE": "自信と責任を持って",
    "WINNING": "チームとして勝利します",
    "DIFFERENCE": "違いを生み出すことにコミットしています"
  },
}